import { render, staticRenderFns } from "./FinishedTasks.vue?vue&type=template&id=68a30870&"
import script from "./FinishedTasks.vue?vue&type=script&lang=js&"
export * from "./FinishedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports